import { render } from "./Baby.vue?vue&type=template&id=5f956cd3"
import script from "./Baby.vue?vue&type=script&lang=js"
export * from "./Baby.vue?vue&type=script&lang=js"
script.render = render

export default script